import $ from 'jquery';

export default {
    data() {
        return {};
    },
    methods: {
        ajax(action, method, data = {}) {

            return $.ajax({
                url: taaf.ajaxurl,
                type: 'GET',
                dataType: 'json',
                data: {
                    action: action,
                    method: method,
                    ...data
                }
            });

        },
        ajaxPost(action, method, data = {}) {

            return $.ajax({
                url: taaf.ajaxurl,
                type: 'POST',
                dataType: 'json',
                xhrFields: {
                    withCredentials: true
                },
                data: {
                    action: action,
                    method: method,
                    ...data
                }
            });

        },
        ajaxHtml(action, method, data = {}) {

            return $.ajax({
                url: taaf.ajaxurl,
                type: 'GET',
                dataType: 'html',
                data: {
                    action: action,
                    method: method,
                    ...data
                }
            });

        }
    }
};